import { Node } from '@tiptap/core'
import { PluginKey } from '@tiptap/pm/state'
import { Editor, Range } from '@tiptap/react'
import { Suggestion, SuggestionOptions } from '@tiptap/suggestion'

import { MenuItem } from './items.js'
import { renderSlashMenuPopup } from './options.js'

export type SlashMenuOptions = {
  HTMLAttributes: Record<string, unknown>
  command?: ({
    editor,
    props,
    range,
  }: {
    editor: Editor
    props: MenuItem
    range: Range
  }) => void
  suggestion: Omit<SuggestionOptions, 'editor'>
}

export const SlashMenuPluginKey = new PluginKey('slash-menu')

export const SlashMenu = Node.create<SlashMenuOptions>({
  name: 'slash-menu',

  addOptions() {
    return {
      HTMLAttributes: {},
      command: undefined,
      suggestion: {
        char: '/',
        pluginKey: SlashMenuPluginKey,
        // TODO: @Mehrad we should pass the document from the `useDocument` hook
        render: () => renderSlashMenuPopup({ document }),
      },
    }
  },

  group: 'inline',

  inline: true,

  atom: true,

  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        command: this.options.command,
        ...this.options.suggestion,
      }),
    ]
  },
})
